import {assertAndContinue} from 'Asserts';
import {Cell, PastedCell} from 'notebook/tables/constants/CellConstants';
import excess from 'notebook/tables/excess';
import {Anchor} from 'notebook/tables/excess/Tokenizer';

function sanitizeCell(cell: Cell | PastedCell, anchor: Anchor): Cell | PastedCell {
  const text =
    isPastedCell(cell) && cell.formula != null
      ? excess.tokenizer.toAbsoluteFormula(cell.formula, anchor)
      : cell.text != null
        ? cell.text
        : '';

  const whitelistProperties: Array<keyof Cell> = [
    'link',
    'precision',
    'align',
    'foregroundColor',
    'backgroundColor',
    'mergeRowSpan',
    'mergeColSpan',
  ];

  const formats: Array<keyof Cell> = [
    'bold',
    'underline',
    'italic',
    'strikethrough',
    'important',
    'scientificNotation',
  ];

  const sanitizedCell: {
    [k in keyof Cell]: unknown;
  } = {text};

  if (cell.selectorId) {
    // If SelectorConflictResolver was run, cell:PastedCell's `selector` was replaced by a valid `selectorId`.
    sanitizedCell.selectorId = cell.selectorId;
  } else if (isPastedCell(cell) && cell.selector) {
    // If it wasn't, this will help make clear to the end user that their selector did not copy over.
    assertAndContinue(
      false,
      'Expected SelectorConflictResolver to have been run to resolve all selectors on paste.',
      {cell}
    );
    sanitizedCell.selectorId = cell.selector.staticId;
  }
  // We explicitly skip externalCache since sanitizeCell is used to paste cells into a new table, where we
  // don't have any rowData, so the cache will likely be invalid.
  for (const property of whitelistProperties) {
    if (cell.hasOwnProperty(property)) {
      sanitizedCell[property] = cell[property];
    }
  }
  for (const format of formats) {
    if (cell.hasOwnProperty(format)) {
      sanitizedCell[format] = Boolean(cell[format]);
    }
  }
  return sanitizedCell as Cell;
}

function isPastedCell(cell: Cell | PastedCell): cell is PastedCell {
  return (cell as PastedCell).formula !== undefined;
}

export default sanitizeCell;
